import React, { useContext, useEffect, useState } from 'react';
import { Button, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FitScreenIcon from '@mui/icons-material/FitScreen';
import { LayerContext } from '../LayerContext';
import SquareIcon from '@mui/icons-material/Square';
import './LayerList.css';

const LayerQuickAccessButton = ({ map, layer, layerProps, setLayerProps, titleEditing, setTitleEditing }) => {

  const { dispatch } = useContext(LayerContext);
  const [colorIndicator, setColorIndicator] = useState(null);

  const handleQuickVisibility = (event) => {
    event.stopPropagation();
    // update isLayerVisible
    const updatedLayerProps = layerProps.map(lv => {
      return {
        ...lv,
        visibility: lv.layerId === layer.id ? !lv.visibility : lv.visibility,
      };
    });
    setLayerProps(updatedLayerProps);
  }

  useEffect(() => {
    // set visivility according to the boolean state
    // the visibility in gene group was managed in GroupGeneButtonItems.js
    if (layer.assetType !== "gene_group") {
      if (layerProps?.find(lv => lv.layerId === layer.id)?.visibility) {
        map.current.setLayoutProperty(layer.id, 'visibility', 'visible');
      } else {
        map.current.setLayoutProperty(layer.id, 'visibility', 'none');
      }
    }
  }, [layerProps]);

  useEffect(() => {
    const propsColor = layerProps.find(l => l.layerId === layer.id)?.color;
    propsColor && setColorIndicator(propsColor);
  }, [layerProps]);

  const handleQuickDeleteLayer = (event) => {
    event.stopPropagation();
    // delete multiple layers for gene group
    if (layer.assetType === "gene_group") {
      layer.subLayerIds?.map(layerId => map.current.removeLayer(layerId));
      layer.sourceId?.map(sourceId => map.current.removeSource(sourceId));
    } else {
      map.current?.removeLayer(layer.id);
      map.current?.removeSource(layer.sourceId);
    }
    dispatch({ type: 'DELETE_LAYER', payload: layer.id });
  }
 
  const handleEditLayerTitle = (event) => {
    event.stopPropagation();
    setTitleEditing(!titleEditing);
  }

  const zoomToExtent = (event) => {
    event.stopPropagation();
    // for the gene group, zoom to extent for the first layer in the group
    const sourceId = layer.assetType === "gene_group" && Array.isArray(layer.sourceId) ? layer.sourceId[0] : layer.sourceId;
    const source = map.current.getSource(sourceId);
    if (source && source.bounds) {
      map.current.fitBounds(source.bounds);
    } else {
      if (layer?.bounds) map.current.fitBounds(layer.bounds, { padding: 300 });
    }
  };

  return (
    <>
      <Tooltip title={layerProps?.find(lv => lv.layerId === layer.id)?.visibility ? "HIDE" : "UNHIDE"}>
        <Button
          className="compactButton"
          startIcon={layerProps?.find(lv => lv.layerId === layer.id)?.visibility ? <VisibilityIcon /> : <VisibilityOffIcon />}
          onClick={handleQuickVisibility}></Button>
      </Tooltip>
      <Tooltip title="ZOOM TO EXTENT">
        <Button
          className="compactButton"
          startIcon={<FitScreenIcon />}
          onClick={zoomToExtent}></Button>
      </Tooltip>
      <Tooltip title="DELETE">
        <Button
          className="compactButton"
          startIcon={<DeleteIcon />}
          onClick={handleQuickDeleteLayer}></Button>
      </Tooltip>
      {(layer.assetType === "gene" || layer.assetType === "gene_group" && colorIndicator) &&
        <Tooltip title="Gene Color">
          <Button
            className="compactButton"
            startIcon={<SquareIcon style={{color:colorIndicator}} />}></Button>
        </Tooltip>
      }

    </>
  )
}

export default LayerQuickAccessButton;